function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 128.539,
  cy: 48.856,
  r: 16.652
}), /*#__PURE__*/React.createElement("path", {
  d: "m139.977 136.456c6.503-6.503 6.503-17.046 0-23.549s-17.046-6.503-23.549 0-6.503 17.046 0 23.549 17.047 6.503 23.549 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m389.785 353.678c-8.693 3.001-13.307 12.482-10.306 21.175s12.482 13.307 21.175 10.306 13.307-12.482 10.306-21.175c-3.002-8.694-12.482-13.308-21.175-10.306z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m456.718 377.94c-8.693 3.001-13.307 12.482-10.306 21.175s12.482 13.307 21.175 10.306 13.307-12.482 10.306-21.175c-3.002-8.693-12.482-13.307-21.175-10.306z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m281.124 239.008c-1.255-4.037-4.416-7.199-8.453-8.453l-32.844-10.21c-.616-.192-1.288-.026-1.745.431l-163.803 163.802c-.696.696-.695 1.834.001 2.53l.013.013 50.911 50.91c.213.213.401.442.6.664l165.099-165.099c.457-.457.622-1.128.431-1.745z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m510.512 213.606-55.318-74.128c-3.278-4.392-4.185-10.116-2.424-15.307l29.704-87.595c1.547-4.563-2.81-8.92-7.373-7.373l-87.595 29.704c-5.19 1.76-10.914.854-15.307-2.424l-74.129-55.317c-3.862-2.882-9.352-.084-9.29 4.734l1.183 92.486c.069 5.48-2.562 10.644-7.036 13.808l-75.519 53.406c-3.934 2.782-2.97 8.868 1.631 10.299l88.325 27.455c5.234 1.627 9.332 5.725 10.959 10.959l27.455 88.325c1.43 4.602 7.516 5.565 10.299 1.631l53.406-75.519c3.123-4.417 8.195-7.037 13.595-7.037.072 0 .143 0 .214.001l92.486 1.182c4.819.062 7.616-5.428 4.734-9.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m50.743 410.67c-.004-.004-.009-.009-.013-.013-.692-.694-1.8-.73-2.493-.037l-37.298 37.298c-14.586 14.586-14.586 38.234 0 52.821 14.586 14.586 38.235 14.586 52.821 0l38.558-38.558c-.222-.199-.451-.387-.664-.6z"
}));

var SvgWand = function SvgWand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.677 511.677",
    height: 512,
    viewBox: "0 0 511.677 511.677",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wand.809a5fb2.svg";
export { ForwardRef as ReactComponent };